// Days on which running strategy is allowed
export const ALLOWED_STRATEGY_DAYS = ['M', 'T', 'W', 'Th', 'F', 'Sa', 'Su'];
